import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';

export class CustomValidators {
  static dateMinimum(date: string, canBeEqual: boolean = false): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value == null) {
        return null;
      }

      const controlDate = moment(control.value).hour(0).minute(0);

      if (!controlDate.isValid()) {
        return null;
      }

      const validationDate = moment(date);

      return controlDate.isAfter(validationDate) || (canBeEqual && controlDate.isSameOrAfter(validationDate)) ? null : {
        'date-minimum': {
          'date-minimum': validationDate.format("M/D/YYYY"),
          'actual': controlDate.format("M/D/YYYY")
        }
      };
    };
  }

  static dateMaximum(date: string, canBeEqual: boolean = false): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value == null) {
        return null;
      }

      const controlDate = moment(control.value).startOf('day');

      if (!controlDate.isValid()) {
        return null;
      }

      const validationDate = moment(date);

      return controlDate.isBefore(validationDate) || (canBeEqual && controlDate.isSameOrBefore(validationDate)) ? null : {
        'date-maximum': {
          'date-maximum': validationDate.format("M/D/YYYY"),
          'actual': controlDate.format("M/D/YYYY")
        }
      };
    };
  }

  static emailValidation(control: AbstractControl) {
    var emailPattern: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (control.value == null || control.value == "")
      return null;

    if (!emailPattern.test(control.value)) {
      return { "pattern": true };
    }
    return null;
  }


  static isDate(c: AbstractControl) {

    var date = c.value;


    if (date == null || date == "") {      
      return null;
    }


    try {

      var dateRegex = /\w{3,} \w{3,} \d{1,2} \d{4,} \d{1,2}:\d{1,2}:\d{1,2} GMT-\d{4,} \((\w+( )*)*\)/g;
      if (!dateRegex.test(date)) {        
        return { 'invalidFormat': true };
      }
      else {        
        return null;
      }
    }
    catch {
      return { 'invalidFormat': true };
    }
  }

  static isDateString(date: string): boolean {

    if (date == null)
      return true;

    try {

      var dateRegex = /\w{3,} \w{3,} \d{1,2} \d{4,} \d{1,2}:\d{1,2}:\d{1,2} GMT-\d{4,} \((\w+( )*)*\)/g;

      if (!dateRegex.test(date))
        return false;

      return true;
    }
    catch {
      return false;
    }
  }

}
